<template>
   <div>
      <!-- main-area -->
      <main class="fix">
         <div class="text-center">
            <div id="carouselExampleIndicators" class="carousel slide" data-bs-ride="carousel">
               <div class="carousel-indicators">
                  <button v-for="(data, idx) in list_slider" :key="data.id" type="button"
                     data-bs-target="#carouselExampleIndicators" :data-bs-slide-to="idx" :class="cek_active(idx)"
                     aria-current="true"></button>
               </div>
               <div class="carousel-inner">
                  <div v-for="(data, idx) in list_slider" :key="data.id" :class="'carousel-item ' + cek_active(idx)">
                     <img :src="file_path + data.file" class="d-block w-100 img-responsive full-sc" alt="..."
                        style="position: relative;">
                  </div>
               </div>
               <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators"
                  data-bs-slide="prev">
                  <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                  <span class="visually-hidden">Previous</span>
               </button>
               <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators"
                  data-bs-slide="next">
                  <span class="carousel-control-next-icon" aria-hidden="true"></span>
                  <span class="visually-hidden">Next</span>
               </button>
            </div>
         </div>

         <section class="about__area-two about__bg">
            <div class="bg-img position-absolute top-0 bottom-0 start-0 w-100 h-100"
               data-background="assets/img/bg/about_bg.jpg"></div>
            <div class="container">
               <div class="row align-items-center justify-content-center">
                  <div class="col-lg-6 col-md-8">
                     <div class="testimonial__img-wrap-two">
                        <img :src="file_path + sambutan_foto" alt="Apexa" style="width: 421px; height: 513px;" />
                        <div class="testimonial__img-shape-two">
                           <img src="assets/img/images/h3_testimonial_shape01.png" alt="Apexa" class="alltuchtopdown" />
                           <img src="assets/img/images/h3_testimonial_shape02.png" alt="Apexa" class="rotateme" />
                           <img src="assets/img/images/h3_testimonial_shape03.png" alt="Apexa" />
                        </div>
                     </div>
                  </div>
                  <div class="col-lg-6">
                     <div class="about__content-two">
                        <div class="section-title mb-20 tg-heading-subheading animation-style3">
                           <span class="sub-title">Dinas Lingkungan Hidup</span>
                           <h2 class="title tg-element-title text-primary">{{ sambutan_nama }}</h2>
                        </div>
                        <p v-html="sambutan_isi"></p>
                     </div>
                  </div>
               </div>
            </div>
            <div class="about__shape-wrap-two">
               <img src="assets/img/images/h2_about_shape01.png" alt="Apexa"
                  data-parallax='{"x" : -80 , "y" : 80 , "rotateZ":80}' />
               <img src="assets/img/images/h2_about_shape02.png" alt="Apexa" data-parallax='{"y" : 100 }' />
               <img class="dark-opacity" src="assets/img/images/h2_about_shape03.png" alt="Apexa" data-aos="fade-left"
                  data-aos-delay="400" />
            </div>
         </section>

         <section class="about__area-six">
            <div class="container">
               <div class="row align-items-center justify-content-center">
                  <div class="col-lg-6 col-md-8">
                     <div class="about__content-six">
                        <div class="section-title mb-25">
                           <h2 class="title">
                              Tentang Kami
                           </h2>
                        </div>
                        <p class="text-justify">Dinas Lingkungan Hidup Kabupaten Konawe Selatan hadir sebagai garda
                           terdepan dalam menjaga kelestarian alam dan kualitas hidup masyarakat.
                           Dengan semangat kerja cepat dan tanpa mengenal hari libur, kami terus menjalankan program
                           strategis demi menciptakan lingkungan yang bersih, hijau, dan berkelanjutan.
                           #KonSelSetara <br>
                           #DlhGerCepDanPatroliLiburPunTetapBekerja
                        </p>
                        <div class="about__content-inner-four">
                           <div class="about__list-box">
                              <ul class="list-wrap">
                                 <li><i class="flaticon-arrow-button"></i>Pengelolaan Sampah Terpadu</li>
                                 <li><i class="flaticon-arrow-button"></i>Pengawasan & Patroli Rutin</li>
                                 <li><i class="flaticon-arrow-button"></i>Aksi Hijau Berkelanjutan</li>
                              </ul>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="col-lg-6">
                     <div class="about__img-wrap-six">
                        <img src="assets/img/aboutUs1.jpg" alt="Apexa" />
                        <div class="shape">
                           <img src="assets/img/images/h4_about_img_shape.png" alt="Apexa"
                              class="dark-opacity alltuchtopdown" />
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <div class="about__shape-wrap-four">
               <img class="dark-opacity" src="assets/img/images/h4_about_shape01.png" alt="Apexa" />
               <img src="assets/img/images/h4_about_shape02.png" alt="Apexa" data-parallax='{"x" : -80 , "y" : -80 }' />
            </div>
         </section>

         <section class="blog__post-area-two blog__post-bg-two">
            <div class="bg-img position-absolute top-0 bottom-0 start-0 w-100 h-100"
               data-background="assets/img/bg/blog_post_bg.jpg"></div>
            <div class="container position-relative z-1">
               <div class="row justify-content-center">
                  <div class="col-xl-6">
                     <div class="section-title text-center mb-40 tg-heading-subheading animation-style3">
                        <span class="sub-title">BERITA TERBARU</span>
                        <h2 class="title tg-element-title text-primary">Berita dan Wawasan Unggulan</h2>
                     </div>
                  </div>
               </div>
               <div class="row justify-content-center">
                  <div class="col-xl-4 col-lg-6 col-md-10" v-for="data in list_berita" :key="data.id">
                     <div class="blog-post-item shine-animate-item">
                        <div class="blog-post-thumb">
                           <a href="javascript:void(0);" @click="push_berita(data.id)" class="shine-animate"><img
                                 :src="file_path + data.foto" alt="Apexa" /></a>
                           <a href="javascript:void(0);" class="post-tag">{{ data.kategori_id }}</a>
                        </div>
                        <div class="blog-post-content">
                           <h2 class="title"><a href="javascript:void(0);" @click="push_berita(data.id)">{{
                              data.judul }}</a></h2>
                           <div class="blog-avatar">
                              <div class="avatar-content">
                                 <p>By <a href="javascript:void(0);">{{ data.createBy }}</a></p>
                              </div>
                           </div>
                           <div class="blog-post-meta">
                              <ul class="list-wrap">
                                 <li>
                                    <a href="javascript:void(0);" @click="push_berita(data.id)" class="btn">Baca
                                       Selengkapnya</a>
                                 </li>
                                 <li><i class="fas fa-calendar-alt"></i>{{ UMUM.tglConvert(data.createAt) }}
                                 </li>
                              </ul>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="text-center">
                  <router-link to="/berita" class="btn">Berita Lainnya</router-link>
               </div>
            </div>
            <div class="blog-shape-wrap">
               <img src="assets/img/images/blog_shape01.png" alt="Apexa" data-aos="fade-right" data-aos-delay="400" />
               <img src="assets/img/images/blog_shape02.png" alt="Apexa" data-aos="fade-left" data-aos-delay="400" />
            </div>
         </section>

         <section class="project-area">
            <div class="container">
               <div class="row justify-content-center">
                  <div class="col-xl-6 col-lg-7">
                     <div class="section-title text-center mb-50 tg-heading-subheading animation-style3">
                        <span class="sub-title">Foto Kegiatan Terbaru</span>
                        <h2 class="title tg-element-title">Mari Temukan Semua Foto Kegiatan Terbaru Kami</h2>
                     </div>
                  </div>
               </div>
            </div>
            <section class="blog_area mt-5">
               <div class="container">
                  <div class="row">
                     <div class="col-lg-4 col-md-6" v-for="data in list_foto" :key="data.id">
                        <div class="project__item-two">
                           <div class="project__thumb-two">
                              <img :src="file_path + data.file" alt="Apexa" />
                           </div>
                           <div class="project__content-two">
                              <h2 class="title"><a href="javascript:void(0)" data-bs-toggle="modal" data-bs-target="#exampleModal" @click="selectDataFoto(data)">{{ data.judul }}</a></h2>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="text-center">
                     <router-link to="/foto" class="btn">Foto Lainnya</router-link>
                  </div>
                  <div class="modal fade" id="exampleModal" tabindex="-1" aria-hidden="true">
                     <div class="modal-dialog modal-lg">
                        <div class="modal-content">
                           <div class="modal-header">
                              <h5 class="modal-title">Lampiran</h5>
                              <button type="button" class="btn-close" data-bs-dismiss="modal"
                                 aria-label="Close"></button>
                           </div>
                           <div class="modal-body">
                              <div class="text-center">
                                 <img class="img-responsive" :src="file_path + galeryku.file" alt="clients">
                              </div>
                              <hr>
                              <h5><b>{{ galeryku.judul }}</b></h5>
                              <hr>
                              <p>{{ galeryku.deskripsi }}</p>
                           </div>
                           <div class="modal-footer">
                              <button type="button" class="blog__post-tag-two" data-bs-dismiss="modal">Keluar</button>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="project__shape-wrap-two">
                  <img class="dark-opacity" src="assets/img/project/h2_project_shape.png" alt="Apexa"
                     data-aos="fade-left" data-aos-delay="400" />
               </div>
            </section>
            <div class="project-shape-wrap">
               <img src="assets/img/project/project_shape02.png" alt="Apexa" class="rotateme" />
            </div>
         </section>
         <div class="brand-area">
            <div class="container">
               <div class="swiper-container brand-active">
                  <div class="swiper-wrapper">
                     <div class="swiper-slide" v-for="data in list_link_terkait" :key="data.id">
                        <div class="brand-item">
                           <a :href="data.url" target="_blank">
                              <img :src="file_path + data.file" alt="Apexa" style="width: 100px; height: auto;" />
                           </a>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </main>
   </div>
</template>

<script>
import UMUM from "../library/umum";

export default {
   data() {
      return {
         activeIndex: 0,

         id: "",
         list_slider: [],
         list_berita: [],
         list_foto: [],
         list_link_terkait: [],
         list_layanan: [],
         unit_kerja: this.$store.state.UNIT_KERJA,
         UMUM: UMUM,

         sambutan_nama: "",
         sambutan_foto: "",
         sambutan_isi: "",

         file_path: this.$store.state.url.URL_APP + "uploads/",
         galeryku: {
            id: '',
            judul: '',
            deskripsi: '',
            file: '',
            unit_kerja: '',
            status: '',
            createBy: '',
            createAt: '',
         },
         form: {
            id: '',
            kategori: '',
            uraian: '',
         },
      }
   },


   methods: {

      getSlider: function () {
         fetch(this.$store.state.url.URL_SLIDER, {
            method: "GET",
            headers: {
               "content-type": "application/json",
               authorization: "kikensbatara " + localStorage.token
            },
         })
            .then(res => res.json())
            .then(res_data => {
               this.list_slider = res_data
               // console.log(res_data);
            });
      },

      getSambutan: function () {
         fetch(this.$store.state.url.URL_SAMBUTAN + "view", {
            method: "get",
            headers: {
               "content-type": "application/json",
            },

         })
            .then(res => res.json())
            .then(res_data => {
               var sambutan = res_data[0];

               this.sambutan_nama = sambutan.nama;
               this.sambutan_foto = sambutan.foto;
               this.sambutan_isi = sambutan.isi;
               // console.log(res_data);

            });
      },

      getListBerita: function () {
         fetch(this.$store.state.url.URL_BERITA + "homeOPD", {
            method: "POST",
            headers: {
               "content-type": "application/json",
               authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
               unit_kerja: this.unit_kerja,

            })
         })
            .then(res => res.json())
            .then(res_data => {
               this.list_berita = res_data;
               // console.log(res_data);
            });
      },

      getLinkTerkait: function () {
         fetch(this.$store.state.url.URL_LINK_TERKAIT, {
            method: "POST",
            headers: {
               "content-type": "application/json",
               authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
               unit_kerja: this.unit_kerja,
            })
         })
            .then(res => res.json())
            .then(res_data => {
               this.list_link_terkait = res_data;
               // this.cek_load_data = false;
               // console.log(res_data);
            });
      },

      getFoto: function () {
         fetch(this.$store.state.url.URL_FOTO, {
            method: "GET",
            headers: {
               "content-type": "application/json",
            },
         })
            .then(res => res.json())
            .then(res_data => {
               this.list_foto = res_data
               // console.log(res_data);
            });
      },

      // getLayanan: function () {
      //    fetch(this.$store.state.url.URL_LAYANAN, {
      //       method: "GET",
      //       headers: {
      //          "content-type": "application/json",
      //       },
      //    })
      //       .then(res => res.json())
      //       .then(res_data => {
      //          this.list_layanan = res_data
      //          console.log(res_data);
      //       });
      // },

      selectDataFoto: function (data) {
         this.galeryku = {
            id: data.id,
            judul: data.judul,
            deskripsi: data.deskripsi,
            file: data.file,
            unit_kerja: data.unit_kerja,
            status: data.status,
            createBy: data.createBy,
            createAt: data.createAt,
         };
         // console.log(data);
      },

      cek_active: function (data) {
         if (data == 0) {
            return 'active'
         }
      },

      push_berita: function (id) {
         this.$router.push('/isiBerita?id=' + id);
      },

      buka_modal: function (modalku) {
         var modal = document.getElementById(modalku);
         modal.style.display = "block";
      },

      tutup_modal: function (modalku) {
         var modal = document.getElementById(modalku);
         modal.style.display = "none";
      },

      active(idx) {
         return idx === this.activeIndex ? 'active' : '';
      },

      potongKata(text, limit) {
         const words = text.split(' ');
         if (words.length <= limit) return text;
         return words.slice(0, limit).join(' ');
      }
   },


   mounted() {

      this.getSlider();
      this.getSambutan();
      this.getListBerita();
      this.getFoto();
      this.getLinkTerkait();
      // this.getLayanan();
      // Inisialisasi Swiper
      new window.Swiper('.brand-active', {
         slidesPerView: 5,
         spaceBetween: 30,
         loop: true,
         autoplay: {
            delay: 2000,
            disableOnInteraction: false,
         },
         breakpoints: {
            320: { slidesPerView: 2 },
            768: { slidesPerView: 3 },
            1024: { slidesPerView: 5 }
         }
      })

   },
}
</script>